import { css } from 'styled-components'
import transformProps from '../utils/transformProps'
import { ConfigType, Dictionary, StyleType } from '../utils/transformProps/types'
import { FlexWrap } from '../types'

type OverflowKey = 'overflow'

type FlexWrapKey = 'flexWrap'

type BasicLayoutKeys = 'width' | 'maxWidth' | 'minWidth' | 'height' | 'maxHeight' | 'minHeight'

export type LayoutKeys = OverflowKey | FlexWrapKey | BasicLayoutKeys

type OverflowValues = 'visible' | 'hidden' | 'scroll'
type OverflowProp = {
    [key in OverflowKey]?: OverflowValues | OverflowValues[]
}

type FlexWrapProp = {
    [key in FlexWrapKey]?: FlexWrap | FlexWrap[]
}

export type LayoutProps = OverflowProp &
    FlexWrapProp & {
        [key in BasicLayoutKeys]?: Dictionary
    }

export const layoutConfig: ConfigType<LayoutKeys> = {
    width: {
        property: ['width'],
    },
    maxWidth: {
        property: ['maxWidth'],
    },
    minWidth: {
        property: ['minWidth'],
    },
    height: {
        property: ['height'],
    },
    maxHeight: {
        property: ['maxHeight'],
    },
    minHeight: {
        property: ['minHeight'],
    },
    overflow: {
        property: ['overflow'],
    },
    flexWrap: {
        property: ['flexWrap'],
    },
}

export const layout = css<LayoutProps>`
    ${(props): StyleType => transformProps(layoutConfig, props)}
`
